import script from "./ClientView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientView.vue?vue&type=script&setup=true&lang=js"

import "./ClientView.vue?vue&type=style&index=0&id=3a31c8ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a31c8ac"]])

export default __exports__